import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { MutationCache, QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { App } from './App';
import { ApparenceDeLaPage } from './partage/ApparenceDeLaPage';
import { brancherLaFermeture } from './partage/fermeture';
import { cles } from './partage/relectures';
import './partage/styles/global.css';

brancherLaFermeture();

const client: QueryClient = new QueryClient({
  /*
   * Après chaque écriture, le tuto refait le point (tickets 31 et 33) : c'est ainsi
   * qu'il voit un geste fait, où qu'il ait été fait, sans que chaque geste le prévienne.
   */
  mutationCache: new MutationCache({
    onSettled: () => void client.invalidateQueries({ queryKey: cles.tuto }),
  }),
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 5_000,
    },
  },
});

const racine = document.getElementById('racine');
if (!racine) throw new Error('#racine est absent de index.html');

/*
 * Le service worker n'est enregistre qu'en production : en developpement, il servirait des
 * modules perimes a la place de ceux que Vite vient de recompiler, et on passerait ses
 * journees a se demander pourquoi une correction n'apparait pas.
 */
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js').catch(() => {
      // Un service worker refuse (contexte non securise, reglage du navigateur) n'empeche
      // rien : l'app marche, elle ne s'ouvre juste pas hors ligne.
    });
  });
}

createRoot(racine).render(
  <StrictMode>
    <QueryClientProvider client={client}>
      <ApparenceDeLaPage />
      <App />
    </QueryClientProvider>
  </StrictMode>
);
